export default {
  getDepartamentos: state => state.departamentos,
  getDepartamentoEspecifico: state => state.departamento,
  getDepartamentoUse: state => state.departamentoUse,
  getOperadores: state => state.operadores,
}
